
import { Component, Vue, Watch } from 'vue-property-decorator';
import { UserModule } from '../../store/modules/user';
import dialogImgLarge from '@/components/ImgLarge/index.vue';
import { getDeviceAuthMe, batchQrCode } from '@/api/device';
import dialogDeviceDetail from './components/DeviceDetail.vue';
import dialogDeviceRecord from './components/DeviceRecord.vue';
import CustomerDialog from '../../components/CustomerDialog/levelByLevel.vue';
import { checkPermissionUseAndCompany } from '@/utils/permission';
import { Type } from '@/types/permissionType';

@Component({
  name: 'DeviceToBrand',
  components: {
    dialogImgLarge,
    dialogDeviceDetail,
    dialogDeviceRecord,
    CustomerDialog
  }
})
export default class extends Vue {
  private formSearch:any = {
    customerCompanyId: '',
    customerCompanyName: '',
    companyLevel: ''
  };
  private customerReadonly = false;

  @Watch('customerDialogVisible')
  getCustomerVisible(val: boolean) {
    if (val) {
      this.customerReadonly = true;
    } else {
      this.customerReadonly = false;
    }
  }
  private pagination: any = {
    currentPage: 1,
    pageSize: 10,
    total: 0
  };
  @Watch('pagincation', {
    deep: true,
    immediate: true
  })handlePageChange() {
    this.getDeviceAuthMe();
  }

  resetData() {
    this.pagination.currentPage = 1
    this.formSearch = {
      name: ''
    };
    this.handleSearch();
  }

  handleSearch() {
    this.pagination.currentPage = 1
    this.getDeviceAuthMe();
  }

  handleClear() {
    this.resetData();
  }

  getDeviceAuthMe() {
    this.selectedbox = [];
    this.isIndeterminate = false;
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      page: this.pagination.currentPage,
      size: this.pagination.pageSize,
      customer: this.formSearch.customerCompanyId
    };
    getDeviceAuthMe(params).then(res => {
      if (res && res.data) {
        this.pagination.total = res.data.count;
        this.tableData = res.data.list;
      } else {
        this.pagination.total = 0;
      }
    }).catch(err => {
      let msg = err.msg;
      this.tableData = [];
      this.pagination.total = 0;
    });
  }

  private tableData = [];
  private selectedbox = [];
  private checkAll = false;
  private isIndeterminate: any = null;
  private dialogDeviceRecordVisible = false;
  private dialogDeviceDetailVisible = false;
  private customerDialogVisible=false;
  private rowData = {};
  private servicerScompanyId=UserModule.getCompanyId

  private isShowDeviceHistry=false
  created() {
    this.isShowDeviceHistry = checkPermissionUseAndCompany(UserModule.getCompanyId, Type.DeviceHistry);
    this.getDeviceAuthMe();
  }

  handleSelectionChange(value: any) {
    let checkedCount = value.length;
    this.checkAll = checkedCount === this.tableData.length;
    this.isIndeterminate =
      checkedCount > 0 && checkedCount < this.tableData.length;
  }

  // 全选
  handleCheckAllChange(val: boolean) {
    this.selectedbox = val ? this.tableData : [];
    this.isIndeterminate = false;
  }

  handlePageSizeChange(val:number) {
    this.pagination.currentPage = 1;
    this.pagination.pageSize = val;
    this.getDeviceAuthMe();
  }
  handleCurrentChange(val:number) {
    this.pagination.currentPage = val;
    this.getDeviceAuthMe();
  }

  detailsHandle(val: any) {
    this.dialogDeviceDetailVisible = true;
    this.rowData = val;
  }
  closeDetailHandle(value: boolean) {
    this.dialogDeviceDetailVisible = value;
  }

  recordHandle(val:any) {
    this.dialogDeviceRecordVisible = true;
    this.rowData = val;
  }
  closeRecordHandle(value: boolean) {
    this.dialogDeviceRecordVisible = value;
  }
  private ClickCustomer() {
    this.customerDialogVisible = true;
  }
  private closeCustomerDialog(val:any) {
    this.customerDialogVisible = val;
  }
  private selectCustomerHandle(val:any) {
    let customerId = '';
    if (parseInt(val.customer_type) === 1) {
      customerId = val.customer_company_id;
    } else {
      customerId = 'p' + val.customer_user_id;
    }
    this.formSearch.customerCompanyId = customerId;
    this.formSearch.customerCompanyName = val.name;
    this.formSearch.companyLevel = val.company_level;
    this.customerDialogVisible = false;
  }
  private imgLargeHandle(val: [], index: number) {
    let enlargedData = {
      isShow: true,
      imgList: [val],
      initNum: index
    };
    this.$store.dispatch('toggleEnlarged', enlargedData);
  }
  // 导出二维码
  private improtOutQr() {
    if (!this.selectedbox || this.selectedbox.length < 1) {
      this.$notify.warning({
        title: '提示',
        message: '请选择设备'
      });
      return;
    }
    let id = '';
    for (var item of this.selectedbox) {
      id = id + (item as any).id + ',';
    }
    let params:any = {};
    params.company_id = UserModule.getCompanyId;
    params.user_id = UserModule.getUserId;
    params.id = id.substring(0, id.length - 1);
    batchQrCode(params).then(res => {
    }).catch(err => {
      if (!err.msg) {
        let blob = new Blob([err]);
        let fileName = new Date().getTime() + '.pdf';
        if ('download' in document.createElement('a')) {
          // 非IE下载
          let elink = document.createElement('a');
          elink.download = fileName;
          elink.style.display = 'none';
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href); // 释放URL 对象
          document.body.removeChild(elink);
        } else {
        // IE10+下载
          // navigator.msSaveBlob(blob, fileName);
        }
        this.$message.success('下载文件成功');
      } else {
        this.$message.error(err.msg);
      }
    });
  }

  private dropdownHandle(name: any) {
    let funcname: any = this.$options.methods;
    funcname[name].bind(this)();
  }
  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSecussMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }
}
